import { ClaimTypeEnum } from "./claim-type-enum";

export const ClaimTypeLabel = {
  [ClaimTypeEnum.RECEIVE]: "Terima Barang",
  [ClaimTypeEnum.DELIVERY]: "Kirim Barang",
};
